<template>
  <div>
    <Control @add="addItem" @remove="removeItemById" @edit="editItem" />
    <v-data-table
      v-model="selected"
      fixed-header
      :headers="headers || defaultHeaders"
      :items="data"
      :items-per-page="20"
      :footer-props="{
        'items-per-page-options': [20, 50, 100, -1]
      }"
      height="600"
      :single-select="true"
      show-select
      class="simple-table"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      @input="selectItem"
    >
      <template #header.name="{ header }">
        <div class="d-flex justify-space-between align-center">
          <span>{{ header.text }}</span>
          <TwoArrowSort class="simple-table--sort-icon" />
        </div>
      </template>

      <template #header.date="{ header }">
        <div class="d-flex justify-space-between align-center">
          <span>{{ header.text }}</span>
          <TwoArrowSort class="simple-table--sort-icon" />
        </div>
      </template>

      <template #item.date="{ item }">
        {{ formatTime(item.createdAt) }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { get, find } from 'lodash';

import { formatValues } from '@/mixins/formatValues.mixin';
import Control from '@/components/sessions/Control';
import TwoArrowSort from '@/components/common/icons/TwoArrowSort';

export default {
  name: 'EnterpriseTable',
  components: {
    Control,
    TwoArrowSort
  },
  mixins: [formatValues],
  props: {
    data: {
      type: Array,
      default: () => []
    },
    text: {
      type: Object,
      default: () => {}
    },
    headers: {
      type: Array,
      default: undefined
    },
    selectedAction: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      singleSelect: true,
      selected: [],
      sortBy: 'name',
      sortDesc: false
    };
  },
  computed: {
    defaultHeaders() {
      return [
        {
          text: 'Entreprise',
          divider: true,
          align: 'start',
          sortable: true,
          width: '33%',
          value: 'name'
        },
        {
          text: 'Corps de métier',
          divider: true,
          align: 'start',
          sortable: true,
          width: '33%',
          value: 'Profession.label'
        },
        {
          text: 'Créée le ',
          divider: true,
          align: 'start',
          width: '33%',
          sortable: true,
          value: 'date'
        }
      ];
    },
    selectedId() {
      return get(this.selected[0], 'id', null);
    },
    selectedItem() {
      if (!this.selectedId) {
        return {};
      }

      return find(this.data, { id: this.selectedId }) || {};
    }
  },
  methods: {
    selectItem() {
      this.$emit('selectForm', this.selectedId);
    },
    removeItemById() {
      if (!this.selectedId) {
        return;
      }
      this.$modals.open({
        name: 'RemoveItem',
        payload: {
          text: {
            title: this.text.remove.title,
            subTitle: this.text.remove.subTitle
          },
          submit: () => {
            this.$emit('remove', this.selectedId);
            this.selected = [];
          }
        }
      });
    },
    editItem() {
      if (!this.selectedId) {
        return;
      }

      this.$modals.open({
        name: 'ChangeEnterprise',
        payload: {
          text: {
            title: this.text.edit.title
          },
          oldValues: {
            name: this.selectedItem.name,
            professionId: this.selectedItem.professionId
          },
          submit: data => {
            this.$emit('edit', { id: this.selectedId, data });
          }
        }
      });
    },
    addItem() {
      this.$modals.open({
        name: 'ChangeEnterprise',
        payload: {
          text: {
            title: this.text.add.title
          },
          oldValues: null,
          submit: data => {
            this.$emit('add', data);
          }
        }
      });
    }
  }
};
</script>

<style lang="scss">
.sessions-control-icon {
  padding: 0 4px;
}

.simple-table {
  .v-data-table-header__icon {
    display: none;
  }

  .v-input--selection-controls__input {
    .v-icon {
      color: #3dd598 !important;
    }
  }

  &--sort-icon {
    min-width: 24px;
    min-height: 24px;
  }

  tr:nth-child(odd) {
    background-color: #f2f2f2;
  }
  td:nth-child(1) {
    border-left: thin solid rgba(0, 0, 0, 0.12);
  }

  tr:last-child {
    td {
      border-bottom: thin solid rgba(0, 0, 0, 0.12);
    }
  }

  thead {
    th {
      background-color: white;
      border-top: thin solid rgba(0, 0, 0, 0.12);
    }

    th:nth-child(1) {
      border-left: thin solid rgba(0, 0, 0, 0.12);
    }
  }
}
</style>
